import { render, staticRenderFns } from "./usb-parts-matrix-upload.vue?vue&type=template&id=05f2e011&scoped=true&"
import script from "./js/usb-parts-matrix-upload.js?vue&type=script&lang=js&"
export * from "./js/usb-parts-matrix-upload.js?vue&type=script&lang=js&"
import style0 from "./usb-parts-matrix-upload.vue?vue&type=style&index=0&id=05f2e011&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2e011",
  null
  
)

export default component.exports